<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-header class="ask-subject" :style="communityStyle" v-text="$lodash.has(community, 'name') ? community.name + ': ' + ask.subject : ask.subject">
			</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" v-on:chosen="addSeeker" editAsk="true">Ask detail goes here...</ask-detail>
		<md-card class="mt-30">
			<md-card-header>
				<div class="md-title card-header">Details:</div>
			</md-card-header>
			<md-card-content>
				<md-field class="textareaAfter">
					<md-textarea v-model="comment" @input="comment = sanitizeInput($event)" placeholder="..."></md-textarea>
				</md-field>
				<md-ripple>
					<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
				</md-ripple>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import AskDetail from "./AskDetail";
import ActivityLog from "./ActivityLog";
import Comments from "./Comments";
import AskFeedback from "./AskFeedback";
import { sanitizeInput } from '@/utils/sanitizer';
export default {
  components: {
    ActivityLog,
    AskDetail,
    Comments,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      ask: {},
      action: "comment",
      comment: "",
      createdByMember: {},
      community: {},
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      },
      newAdmin: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    sanitizeInput(event) {
      return sanitizeInput(event);
    },
    loadData: async function() {
      this.action = this.$route.params.action;
      // console.log("Checking: ", this.action);
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(ask => {
        // console.log("Got back", ask);
        this.ask = ask.data;
        if (this.ask) {
          this.createdByMember = this.ask.createdByMemberID;
          // this.api.get(`members/${this.ask.createdByMemberID}`).then(member => {
          //   this.createdByMember = member.data;
          // });
          this.community = this.ask.community;
          // this.api.get(`communities/${this.ask.community}`).then(community => {
            //this.community = community.data;
            this.community.administrators.map(singleAdmin => {
              if (this.newAdmin.indexOf(singleAdmin.memberId) < 0) {
                  this.newAdmin.push(singleAdmin.memberId);
              }
            })
            if (this.$lodash.has(this.community, 'customSettings')) {
	          	this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
	          	this.communityStyle.color = this.community.customSettings.secondaryColor;
	        }
          // });
        }
      });
    },
    doInteraction: async function() {
      await this.api
        .post(`asks/${this.ask._id}/${this.action}`, {
          comment: this.comment,
          recipients: this.newAdmin
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    },
    getCreatedBy: function() {
      this.createdByMember = this.ask.createdByMemberID;
      // this.api.get(`members/${this.ask.createdByMemberID}`).then(member => {
      //   this.createdByMember = member.data;
      // });
    },
    addSeeker: function(members) {
      this.ask.createdByMemberID = members[0];
      this.getCreatedBy();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Interact.vue